import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/team'

class Store extends BaseStore {
  $listApi = Api.applyList
  $pageSizeKey = 'perPage'

  dealApplyJoin = async (applyId, agree) => {
    const { success } = await Api.dealApplyJoin({ applyId, agree })
    if (success) {
      this.$getList()
    }
  }
}

export default Store
